import React from 'react';
import Layout from '../components/Layout';
import Scroll from '../components/Scroll';
import pic1 from '../assets/images/pic01.jpg';
import pic2 from '../assets/images/pic02.jpg';
import pic3 from '../assets/images/pic03.jpg';
import config from '../../config';
import ReactPlayer from 'react-player';
import { Link } from 'gatsby';

const IndexPage = () => (
  <Layout>
    <section id="banner">
      <div className="inner">
        <h2>{config.heading}</h2>
        <p>{config.subHeading}</p>
        <ul className="actions special">
          <li>
            <Scroll type="id" element="one">
              <a href="/#" className="button primary">
                Explorar
              </a>
            </Scroll>
          </li>
        </ul>
      </div>
      <Scroll type="id" element="one">
        <a href="#one" className="more">
          Aprende más
        </a>
      </Scroll>
    </section>

    <section id="one" className="wrapper style1 special">
      <div className="inner">
        <header className="major">
          <h2>Misión</h2>
          <p>
            Ofrecer una amplia variedad de servicios de consultoría informática
            útiles y accesibles para las empresas de cualquier rubro.
          </p>
        </header>
        <header className="major">
          <h2>Visión</h2>
          <p>
            Ser una casa consultora líder a nivel nacional, reconocida por
            siempre trabajar con las últimas tecnologías en el mercado y llegar
            a ser una de las mejores empresas en las cuales trabajar en El
            Salvador.
          </p>
        </header>
        <ul className="icons major">
          <li>
            <span className="icon fa-gem major style1">
              <span className="label">Lorem</span>
            </span>
          </li>
          <li>
            <span className="icon fa-heart major style2">
              <span className="label">Ipsum</span>
            </span>
          </li>
          <li>
            <span className="icon solid fa-code major style3">
              <span className="label">Dolor</span>
            </span>
          </li>
        </ul>
      </div>
    </section>

    <section id="two" className="wrapper alt style2 nuestros_valores">
      <header className="major">
        <h2>Nuestros valores</h2>
      </header>
      <section className="spotlight">
        <div className="image">
          <img src={pic1} alt="" />
        </div>
        <div className="content">
          <h2>Integridad </h2>
          <p>
            Actuamos con rectitud, honestidad, franqueza y justicia, es decir,
            somos consecuentes con los principios personales y morales.
          </p>
        </div>
      </section>
      <section className="spotlight">
        <div className="image">
          <img src={pic2} alt="" />
        </div>
        <div className="content">
          <h2>Trabajo en equipo.</h2>
          <p>
            Trabajamos con una impecable conexión en todos los ámbitos de la
            empresa.
          </p>
        </div>
      </section>
      <section className="spotlight">
        <div className="image">
          <img src={pic3} alt="" />
        </div>
        <div className="content">
          <h2>Responsabilidad social.</h2>
          <p>
            Buscamos generar un impacto positvo no solo en nuestros clientes y
            nuestros empleados, si no también en la comunidad.
          </p>
        </div>
      </section>
    </section>

    <section id="two" className="wrapper alt style2 conocenos">
      <header className="major">
        <h2>Conócenos</h2>
      </header>
      <div className="video-container">
        <ReactPlayer url="https://www.youtube.com/watch?v=K5JakwbC3nk" />
      </div>
    </section>
    <section id="three" className="wrapper style3 special">
      <div className="inner">
        <header className="major">
          <h2>Nuestros Servicios</h2>
          <p>
            Contamos con un equipo de trabajo con una gran experiencia para
            ayudarle en:
          </p>
        </header>
        <ul className="features">
          <li className="icon  solid fa-laptop">
            <h3>Servicio de consultoría </h3>
          </li>

          <li className="icon solid fa-code">
            <h3>Desarrollo de sistemas informáticos </h3>
          </li>

          <li className="icon fa-flag">
            <h3>Servicio de capacitación </h3>
          </li>
        </ul>
      </div>
    </section>

    <section id="cta" className="wrapper style4">
      <div className="inner">
        <header>
          <h2>Déjanos solucionar tus problemas</h2>
          <p>
            Estas a un par de clicks de contactar con la mejor empresa de
            consultoría informática del país.
          </p>
        </header>
        <ul className="actions stacked">
          <li>
            <Link to="/contacto" style={{ border: 'none' }}>
              <a
                href="mailto:kualiconsultores@gmail.com"
                className="button fit primary"
              >
                Contactar
              </a>
            </Link>
          </li>
          <li>
            <a href="/#" className="button fit">
              Aprender más
            </a>
          </li>
        </ul>
      </div>
    </section>
  </Layout>
);

export default IndexPage;
